import { useId, useState, type KeyboardEvent } from 'react';
import { LABEL_VORSCHLAEGE, MAX_LABELS, MAX_LABEL_LAENGE, labelsBereinigen } from '@beholder/shared/module/budget';

/** Labels einer Einnahme als Marken anzeigen. */
export function LabelMarken({ labels }: { labels: string[] }) {
  if (!labels.length) return null;
  return (
    <span className="bu-labels">
      {labels.map((l) => (
        <span key={l} className="bu-label">
          {l}
        </span>
      ))}
    </span>
  );
}

/**
 * Labels frei eintragen: Enter, Komma oder „Hinzufügen“ übernimmt; Vorschläge aus schon benutzten Labels
 * (Klick fügt hinzu). Schreibweise bekannter Labels wird übernommen.
 */
export function LabelEingabe({ wert, aendern, bekannt }: { wert: string[]; aendern(l: string[]): void; bekannt: string[] }) {
  const [text, setText] = useState('');
  const id = useId();
  const listeId = `${id}-labels`;
  const alleBekannt = [...bekannt, ...LABEL_VORSCHLAEGE.filter((v) => !bekannt.some((b) => b.toLocaleLowerCase('de') === v.toLocaleLowerCase('de')))];
  const gewaehlt = new Set(wert.map((l) => l.toLocaleLowerCase('de')));
  const vorschlaege = alleBekannt.filter((l) => !gewaehlt.has(l.toLocaleLowerCase('de'))).slice(0, 12);
  const voll = wert.length >= MAX_LABELS;

  const hinzu = (roh: string) => {
    const teile = roh.split(',').map((t) => t.trim()).filter(Boolean);
    if (!teile.length) return;
    aendern(labelsBereinigen([...wert, ...teile], alleBekannt));
    setText('');
  };
  const taste = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      hinzu(text);
    } else if (e.key === 'Backspace' && !text && wert.length) {
      aendern(wert.slice(0, -1));
    }
  };

  return (
    <div className="bu-label-eingabe">
      <div className="bu-labels">
        {wert.map((l) => (
          <span key={l} className="bu-label">
            {l}
            <button type="button" aria-label={`Label „${l}“ entfernen`} onClick={() => aendern(wert.filter((x) => x !== l))}>
              ×
            </button>
          </span>
        ))}
        {!voll && (
          <input
            className="bu-label-feld"
            value={text}
            list={listeId}
            maxLength={MAX_LABEL_LAENGE}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={taste}
            onBlur={() => text.trim() && hinzu(text)}
            placeholder={wert.length ? 'weiteres Label …' : 'Label eintippen, Enter …'}
            aria-label="Label hinzufügen"
          />
        )}
        <datalist id={listeId}>
          {vorschlaege.map((l) => (
            <option key={l} value={l} />
          ))}
        </datalist>
      </div>
      {!voll && vorschlaege.length > 0 && (
        <div className="bu-label-vorschlaege">
          {vorschlaege.slice(0, 8).map((l) => (
            <button key={l} type="button" className="bu-label bu-label-vorschlag" onClick={() => hinzu(l)}>
              + {l}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
